import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MinsterPortalProgressComponent } from "../minster-portal-progress/minster-portal-progress.component";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'card-layout',
  standalone: true,
  imports: [MatCardModule, MatIconModule, CommonModule],
  templateUrl: './minster-card.component.html',
  styleUrl: './minster-card.component.css'
})
export class MinsterCardComponent {
    @Input('title') _title?: string;
    @Input('icon') _icon?: string;
    @Input('showProgressBar') _showProgressBar = true;
}
